<template>
  <div class="block">
    <!--- Featured Tab startet -->
    <div class="featured-tab color-red">
      <h3 class="block-title"><span>Les plus populaires</span></h3>
      <ul class="nav nav-tabs">
        <li class="active">
          <a class="animated fadeIn" href="#month_view" data-toggle="tab">
            <span class="tab-head"><span class="tab-text-title">Du mois</span></span>
          </a>
        </li>
        <li>
          <a class="animated fadeIn" href="#week_view" data-toggle="tab">
            <span class="tab-head"><span class="tab-text-title">De la semaine</span></span>
          </a>
        </li>
      </ul>

      <top-articles :domain="websiteUrl" :limit="8">
        <template slot-scope="props">
          <div class="tab-content">
            <div class="tab-pane active animated fadeInRight" id="month_view">
              <div class="row">
                <div class="col-md-6" v-for="article in props.articles.month">
                  <div class="small-article">
                    <small-article-preview :article="article"/>
                  </div>
                </div>
              </div><!-- Tab pane Row 1 end -->
            </div><!-- Tab pane 1 end -->

            <div class="tab-pane animated fadeInRight" id="week_view">
              <div class="row">
                <div class="col-md-6" v-for="article in props.articles.week">
                  <div class="small-article">
                    <small-article-preview :article="article"/>
                  </div>
                </div>
              </div><!-- Tab pane Row 2 end -->
            </div><!-- Tab pane 2 end -->
          </div><!-- tab content -->
        </template>
      </top-articles>
    </div><!-- Technology Tab end -->
    <br/><br/>
    <div class="block-block">
      <last-articles-tags :tags="readMoreTags.map(readMoreTag => readMoreTag.tag)" :limit="4">
        <template slot-scope="props">
          <div class="row">
            <div class="col-md-6 read-more-articles" v-for="readMoreTag in readMoreTags">
              <div :class="`block color-${readMoreTag.color}`">
                <h3 class="block-title"><span>{{ readMoreTag.name }}</span></h3>
                <div v-for="article in props.articles[readMoreTag.tag]">
                  <small-article-preview :article="article" :url="readMoreTag.url"/>
                </div>
              </div>
            </div>
          </div>
        </template>
      </last-articles-tags>
    </div>
  </div>
</template>

<script>
  import { ArticlesQuery, TopArticles, LastArticlesTags, categories } from 'itrnews-vuejs-api';
  import SmallArticlePreview from './elements/SmallArticlePreview';
  import ArticlePreview from './elements/ArticlePreview';
  import website from '../mixins/website';

  export default {
    name: 'ReadMore',
    components: { SmallArticlePreview, ArticlePreview, ArticlesQuery, TopArticles, LastArticlesTags },
    mixins: [website, categories],
    mounted() {
      this.featuredTags = this.getCategories(this.websiteCategory).splice(0, 3);
    },
    data() {
      return {
        featuredTags: [],
      };
    },
  };
</script>

<style scoped>
  .read-more-articles {
    margin-bottom: 25px;
    min-height: 720px;
  }
  .block-title {
    margin-bottom: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReadMore.vue